export const shape = {
  borderRadius: 4,
};
export const customShadows = {
  card: "0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.08)",
  dialog: "0px 8px 24px rgba(0, 0, 0, 0.16)",
  dropdown: "0px 4px 12px rgba(0, 0, 0, 0.12)",
};
export const spacing = 8;
